// src/shared/components/layout/DynamicLandingWrapper.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserStore } from '../../../app/store/useUserStore';
import { Box } from '@mui/material';
import { ClipLoader } from 'react-spinners';
import { LandingLayout } from './LandingLayout';

interface DynamicLandingWrapperProps {
  defaultComponent: React.ReactElement;
}

export const DynamicLandingWrapper: React.FC<DynamicLandingWrapperProps> = ({
  defaultComponent
}) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const { user, isProfileLoading } = useUserStore();

  // Show loading while fetching profile
  if (isAuthenticated && isProfileLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <ClipLoader color="#9B1B5A" />
      </Box>
    );
  }

  // For authenticated users, redirect to home page based on their role
  useEffect(() => {
    if (isAuthenticated && user?.user_role) {
      navigate('/', {
        replace: true,
        state: { userRole: user.user_role }
      });
    }
  }, [isAuthenticated, user?.user_role, navigate]);

  // If authenticated user with role, show loading while redirecting (don't render landing page)
  if (isAuthenticated && user?.user_role) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <ClipLoader color="#9B1B5A" />
      </Box>
    );
  }

  // For unauthenticated users, show the default component with LandingLayout
  return (
    <LandingLayout
      showHeader={true}
      showFooter={true}
      showFAB={false}
      userType="generic"
    >
      {defaultComponent}
    </LandingLayout>
  );
};